<div id="boxId" class="box asistente">
  <div id="bannerId" *ngIf="renderChat" class="banner">
    <div *ngIf="renderChat" class="avatar"></div>
    <h1 *ngIf="renderChat"><b>Chat </b> con asesor en línea</h1>
    <div *ngIf="!minimized && !ctx.hideAllButtonsForm" class="min" style="padding-right: 6px" id="minId"
      (click)="minWindows()"></div>
    <div *ngIf="minimized && !ctx.hideAllButtonsForm" class="max" style="padding-right: 6px" id="maxId"
      (click)="maxWindows()"></div>
    <div *ngIf="!minimized && !ctx.hideAllButtonsForm" class="close" style="padding-right: 6px" id="closeId"
      (click)="closeWindows()">
      x
    </div>
  </div>

  <div id="bannerId" *ngIf="renderEmail">
    <app-cabezal *ngIf="!this.minimized" modo="asistente" [ctx]="ctx"></app-cabezal>
  </div>

  <app-cabezal *ngIf="renderMenuArbol && !this.minimized" modo="asistente" [ctx]="ctx"></app-cabezal>
  <div id="divContent" class="divContentStyle">
    <div id="asistente-body">
      <app-asistencia-chat *ngIf="renderChat" (changeContextDataEmitter)="emitChangeContextDataEmitter($event)" (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)" [ctx]="ctx"></app-asistencia-chat>
      <app-asistencia-tramite *ngIf="renderTramite" [ctx]="ctx"></app-asistencia-tramite>
      <app-asistencia-mail *ngIf="renderEmail" [ctx]="ctx" (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)"
        (changeContextDataEmitter)="emitChangeContextDataEmitter($event)"
        [formElements]="formElements"></app-asistencia-mail>
      <app-asistencia-menu-arbol *ngIf="renderMenuArbol" [ctx]="ctx"
        (renderMenuArbolEmitter)="emitRenderMenuArbol($event)"></app-asistencia-menu-arbol>
    </div>
  </div>
  <app-pie [ctx]="ctx" (boton_funcion)="minimizarMaximizar()" *ngIf="!renderChat" modo="asistente" [minimizado]="this.minimized"></app-pie>
  <app-pie [ctx]="ctx" (boton_funcion)="minimizarMaximizar()" *ngIf="renderChat"  modo="chat" [minimizado]="this.minimized"></app-pie>
</div>